import { banhangKiotLike } from '@/components/layout/banhangKiotTokens'

export type FieldSurface = 'form' | 'filterToolbar' | 'filterSidebar' | 'pos' | 'posUnderline'

export type FormFieldLabelLayout = 'outline' | 'above'

export type FormFieldSize = 'small' | 'medium'

/** `box` = viền 4 cạnh (form admin); `underline` = chỉ gạch chân (POS cột giao hàng). */
export type FieldInputChrome = 'box' | 'underline'

/** Token style chung — mỗi surface có bản copy riêng để chỉnh độc lập sau này. */
export type FieldSurfaceStyle = {
  readonly fontFamily: string
  readonly labelFontSizePx: number
  readonly labelFontWeight: number
  readonly labelColor: string
  readonly inputFontSizePx: number
  readonly inputFontWeight: number
  readonly inputColor: string
  readonly placeholderColor: string
  readonly textSecondary: string
  readonly textMuted: string
  readonly borderColor: string
  readonly borderHover: string
  readonly focusColor: string
  readonly focusShadow: string
  readonly inputBg: string
  readonly inputPaddingX: number
  readonly inputBgDisabled: string
  readonly inputHeightPx: number
  readonly borderRadiusPx: number
  readonly labelGapPx: number
  readonly lineHeight: number
  readonly surfaceBg: string
  /** Mặc định `box`. */
  readonly inputChrome?: FieldInputChrome
}

export type FieldSurfaceDefaults = {
  readonly labelLayout: FormFieldLabelLayout
  /** Với `outline`: luôn đặt nhãn trên viền (không nằm giữa ô khi trống). */
  readonly labelShrink?: boolean
  readonly size: FormFieldSize
  readonly variant: 'outlined'
  readonly fullWidth: boolean
  /** Dùng `label` làm placeholder, không hiện nhãn phía trên (kiểu Kiot cột giao hàng). */
  readonly useLabelAsPlaceholder?: boolean
}

/** Tạo bộ token từ `banhangKiotLike` — form là nguồn gốc; filter copy để tách file. */
export function buildFieldSurfaceStyleFromKiot(): FieldSurfaceStyle {
  const k = banhangKiotLike
  return {
    fontFamily: k.kiotFontStack,
    labelFontSizePx: k.kiotFormLabelFontSizePx,
    labelFontWeight: k.kiotFormLabelFontWeight,
    labelColor: k.kiotFormLabelColor,
    inputFontSizePx: k.kiotFormInputFontSizePx,
    inputFontWeight: k.kiotFormInputFontWeight,
    inputColor: k.kiotFormInputColor,
    placeholderColor: k.kiotFormPlaceholderColor,
    textSecondary: k.kiotTextSecondary,
    textMuted: k.kiotTextMuted,
    borderColor: k.kiotFormInputBorder,
    borderHover: k.kiotFormInputBorderHover,
    focusColor: k.kiotFormInputBorderFocus,
    focusShadow: k.kiotFormInputFocusShadow,
    inputBg: k.kiotFormInputBg,
    inputPaddingX: k.kiotFormInputPaddingX,
    inputBgDisabled: k.kiotFormInputBgDisabled,
    inputHeightPx: k.kiotFormInputHeightPx,
    borderRadiusPx: k.kiotFormInputRadiusPx,
    labelGapPx: k.kiotFormLabelGapPx,
    lineHeight: k.kiotLineHeight,
    surfaceBg: k.kiotFormSurfaceBg,
  }
}
